import React, { useContext } from "react";
import { AppContext } from "../Westwordle";

function GameOver(props) {
    const {
        currAttempt,
        gameOver,
        correctWord,
        results,
    } = useContext(AppContext);

    let name = "    Westwords\n";

    let web = "\ndailybruin.com/category/games";

    return (props.trigger) ? (
        <div className="gameOver">
            <div className="inner">
                <div className="title">
                    {gameOver.guessedWord
                        ? "You Got It!"
                        : "Next Time!"}
                </div>
                <div>Correct Word: {correctWord}</div>
                {gameOver.guessedWord && (
                    <h3>You guessed in {currAttempt.attempt} attempts</h3>
                )}
                <div className='close-btn' onClick={() => props.setTrigger()}>
                    <svg xmlns="http://www.w3.org/2000/svg"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                        fill="#D3D7C6"
                        alt='Close'>
                        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" /></svg>
                </div>
                <div className="copy-btn" onClick={() => { window.navigator.clipboard.writeText(name.concat(results.toString().replace(/,/g, "")).concat(web))}}>Copy Results</div>
            </div>
        </div>
    ) : "";
}

export default GameOver;